module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2vAme"))).then(() => parcelRequire('5erN3'));